<template>
    <div class="row daftar--pengiriman">
        <div 
            class="col-md-3"
            style="font: normal normal normal 18px/27px Poppins;">
            <p style="font: normal normal normal 18px/27px Poppins;"><b>NOPOL:</b> {{ data.nopol }}</p>
            <p style="font: normal normal normal 18px/27px Poppins;"><b>No TO:</b> {{ data.no_to ? data.no_to : 'N/A' }}</p>
            <p style="font: normal normal normal 18px/27px Poppins;"><b>Rute:</b> {{ data.current_route ? data.current_route : 'N/A' }}</p>
        </div>
        <div class="col-md-9" style="display: flex; flex-direction: column; justify-content: center;">
            <div class="row">
                <div class="col-11" style="display: flex; flex-direction: column; justify-content: center;">
                    <div class="progress">
                      <div class="progress-bar-cancel" role="progressbar" :style="progressBarCancel" :aria-valuenow="ariaValueNowCancel" aria-valuemin="0" aria-valuemax="100">{{ ariaValueNowCancel }}</div>
                      <div class="progress-bar" role="progressbar" :style="progressBarWidth" :aria-valuenow="ariaValueNow" aria-valuemin="0" aria-valuemax="100">{{ ariaValueNow }}</div>
                    </div>
                </div>
                <div class="col-1">
                    <span style="font-size: 20px; font: normal normal normal 20px/30px Poppins;">{{data.jumlah_dealer_terkirim}}/{{data.jumlah_dealer}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {

            }
        },
        props : ['data'],
        mounted () {

        },
        computed : {
            progressBarWidth () {
                return {
                    "width" : (parseInt(this.data.jumlah_terkirim) / parseInt(this.data.jumlah_dealer) * 100).toFixed() + "%"
                }
            },
            progressBarCancel () {
                return {
                    "width" : (parseInt(this.data.jumlah_cancel) / parseInt(this.data.jumlah_dealer) * 100).toFixed() + "%"
                }
            },
            ariaValueNow () {
                return this.data.jumlah_terkirim
            },
            ariaValueNowCancel () {
                return this.data.jumlah_cancel
            }
        },
        methods : {

        }
    }
</script>

<style scoped>
    .daftar--pengiriman {
        margin: 20px 0;
    }

    .daftar--pengiriman p {
        margin-bottom: 0;
        font-size: 20px;
    }

    .progress-bar {
        background-color: #61FB50;
        text-align: center;
        color: white;
    }

    .progress-bar-cancel {
        background-color: #FF919E;
        text-align: center;
        color: white;
    }
</style>